// Commercial status of an ad (newarc-site #782): the `market` block websiteSync
// (newarc-cloud-functions) writes on every websiteAdsV2 doc —
//   market: { status, soldAt, delisted, priceDrop: { previousPrice, price, at } | null } | null
// and, per taglio, `children[i].market: { status, priceDrop }`. Every doc
// synced before the field existed has none: an ad without `market` is
// available with no price drop, i.e. exactly what the site showed before.
// One place for reading the contract and for the copy, shared by the ad
// classes, the listings and the detail page. Lifecycle: docs/websiteAdsV2.md.

export const MARKET_AVAILABLE = 'available';
export const MARKET_NEGOTIATION = 'negotiation';
export const MARKET_SOLD = 'sold';

// A price drop stays news (badge, struck-through price) for this long.
export const PRICE_DROP_WINDOW_DAYS = 30;

const DAY_MS = 24 * 60 * 60 * 1000;

// Copy: card badges, detail-page pills, taglio tags.
export const MARKET_STATUS_LABELS = {
  [MARKET_NEGOTIATION]: 'In trattativa',
  [MARKET_SOLD]: 'Venduto',
};
export const PRICE_DROP_LABEL = 'Prezzo ribassato';

// Unknown or missing status → available: a status this build does not know
// must neither hide the ad nor mislabel it.
export function normalizeMarketStatus(status) {
  return status === MARKET_NEGOTIATION || status === MARKET_SOLD ? status : MARKET_AVAILABLE;
}

// "Venduto" / "In trattativa"; '' for an available ad.
export function marketStatusLabel(status) {
  return MARKET_STATUS_LABELS[normalizeMarketStatus(status)] || '';
}

function finiteNumber(value) {
  return typeof value === 'number' && Number.isFinite(value) ? value : null;
}

// Defensive read of the block: missing or malformed → available, not
// delisted, no drop; a non-numeric number → null.
export function normalizeMarket(raw) {
  const m = raw && typeof raw === 'object' && !Array.isArray(raw) ? raw : {};
  const drop = m.priceDrop && typeof m.priceDrop === 'object' && !Array.isArray(m.priceDrop)
    ? m.priceDrop
    : null;
  return {
    status: normalizeMarketStatus(m.status),
    soldAt: finiteNumber(m.soldAt),
    delisted: m.delisted === true,
    priceDrop: drop
      ? {
        previousPrice: finiteNumber(drop.previousPrice),
        price: finiteNumber(drop.price),
        at: finiteNumber(drop.at),
      }
      : null,
  };
}

// The (normalized) price drop while it is still news: a real drop
// (previousPrice > price > 0) less than PRICE_DROP_WINDOW_DAYS before `now`.
// Otherwise null.
export function activePriceDrop(drop, now) {
  if (!drop || drop.at === null) return null;
  const isDrop = drop.price > 0 && drop.previousPrice > drop.price;
  const isRecent = now - drop.at < PRICE_DROP_WINDOW_DAYS * DAY_MS;
  return isDrop && isRecent
    ? { previousPrice: drop.previousPrice, price: drop.price, at: drop.at }
    : null;
}
